import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dropdown from "../../layouts/dropdown/Dropdown";
import ActDropdown from "../../layouts/dropdown/ActDropdown";
import StatusDropdown from "../../layouts/dropdown/StatusDropdown";
import CalenderDropdown from "../../layouts/dropdown/CalenderDropdown";
import { requestApi } from "../../../request-api";
import VectorIcon from "../../../assets/image/Vector.svg";
import Closed from "../../../assets/image/Closed.svg";
import { isLocalDateInRange } from "../../../helpers/complianceDashboard";
function Report() {
  const location = useLocation();
  // Initialize with current month dates
  const getCurrentMonthDates = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return { start, end };
  };

  
  const [compliance, setCompliance] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);
  const { start: defaultStart, end: defaultEnd } = getCurrentMonthDates();
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [selectedRange, setSelectedRange] = useState("This Month");
  const [search, setSearch] = useState(" ");
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(" ");
  const [selectedComplianceStatus, setSelectedComplianceStatus] = useState([]);
  const dateDropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [companies, setCompanies] = useState([]);
  const [companies1, setCompanies1] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItems1, setSelectedItems1] = useState([]);
  const [search1, setSearch1] = useState("");
  const [selectedActs, setSelectedActs] = useState([]);
  const [availableActs, setAvailableActs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [subBranches, setSubBranches] = useState([]);
  const [selectedSubBranches, setSelectedSubBranches] = useState([]);
  const [availableSubBranches, setAvailableSubBranches] = useState([]);
  const [loadingCount, setLoadingCount] = useState(0);
  const [selectedComplianceIds, setSelectedComplianceIds] = useState([]);
  const loading = loadingCount > 0;

  const dropdownRef = useRef(null);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    if (location?.state) {
      const {
        status,
        selectedStatus: passedStatus,
        selectedCompany: passedCompany,
        selectedLocation: passedLoc,
        filterDateWise: passedDateWise,
        startDate: passedStart,
        endDate: passedEnd,
        activeFilter: passedActiveFilter,
        applyDateFilter,
      } = location.state;

      if (passedStatus && passedStatus.length > 0) {
        setSelectedComplianceStatus(passedStatus);
      } else if (status) {
        setSelectedComplianceStatus([status]);
      }

      if (passedCompany && (Array.isArray(passedCompany) ? passedCompany.length > 0 : Boolean(passedCompany))) {
        setSelectedItems(Array.isArray(passedCompany) ? passedCompany : [passedCompany]);
      } else {
        setSelectedItems([]);
      }

      if (passedLoc && (Array.isArray(passedLoc) ? passedLoc.length > 0 : Boolean(passedLoc))) {
        setSelectedItems1(Array.isArray(passedLoc) ? passedLoc : [passedLoc]);
      } else {
        setSelectedItems1([]);
      }

      if (applyDateFilter) {
        const sDate = passedDateWise?.startDate || passedStart;
        const eDate = passedDateWise?.endDate || passedEnd;

        if (sDate && eDate) {
          setStartDate(new Date(sDate));
          setEndDate(new Date(eDate));
          setTempStartDate(new Date(sDate));
          setTempEndDate(new Date(eDate));
          if (passedActiveFilter) {
            setSelectedRange(passedActiveFilter);
          } else {
            setSelectedRange("Manual");
          }
        }
      } else {
        setStartDate(null);
        setEndDate(null);
        setTempStartDate(null);
        setTempEndDate(null);
      }
    }
  }, [location?.state]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    selectedItems,
    selectedItems1,
    selectedActs,
    selectedSubBranches,
    selected,
    selectedComplianceStatus,
    startDate,
    endDate,
    searchQuery,
  ]);
  const filteredData = tableData.filter((item) => {
    const companyMatch =
      selectedItems.length === 0 || selectedItems.includes(item.companyName);
    const branchMatch =
      selectedItems1.length === 0 || selectedItems1.includes(item.branchName);
    const actMatch =
      selectedActs.length === 0 || selectedActs.includes(item.act);
    const subBranchMatch =
      selectedSubBranches.length === 0 ||
      selectedSubBranches.includes(item.sub_branch);
    let statusMatch = true;
    if (selected === "Open") statusMatch = item.status == 0;
    else if (selected === "Closed") statusMatch = item.status == 1;

    const complianceStatusMatch =
      selectedComplianceStatus.length === 0 ||
      selectedComplianceStatus.includes(
        item.current_compliance_status ||
        item.currentstatus ||
        item.curr ||
        item.compliance?.current_compliance_status
      );

    const dateMatch = (() => {
      if (!startDate || !endDate) return true;
      return isLocalDateInRange(item.dueDate, startDate, endDate);
    })();

    return (
      companyMatch &&
      branchMatch &&
      actMatch &&
      subBranchMatch &&
      statusMatch &&
      complianceStatusMatch &&
      dateMatch
    );
  });
  const finalFilteredData = filteredData.filter((item) =>
    item?.act?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTableData = finalFilteredData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(finalFilteredData.length / itemsPerPage);
  useEffect(() => {
    const uniqueActs = [
      ...new Set(tableData.map((item) => item.act).filter(Boolean)),
    ];
    setAvailableActs(uniqueActs);
    const uniqueSubBranches = [
      ...new Set(tableData.map((item) => item.sub_branch).filter(Boolean)),
    ];
    setAvailableSubBranches(uniqueSubBranches);
  }, [tableData]);
  const fetchReports = async () => {
    try {
      const res = await axios.get(`${API_URL}/report/reports`);
      if (res.data) {
        setTableData(res.data);
      }
    } catch (err) {
      console.error("Error fetching reports:", err);
    }
  };
  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

    useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await axios.get(`${API_URL}/auditor/company/companies`);
        setCompanies(res.data.data.map((c) => c.company_name));
      } catch (err) {
        console.error("Error fetching companies:", err);
      }
    };

    fetchCompanies();
  }, []);

  useEffect(() => {
    if (tableData.length > 0) {
      const uniqueCompanies = [
        ...new Set(tableData.map((item) => item.companyName)),
      ];
      const uniqueBranches = [
        ...new Set(tableData.map((item) => item.branchName)),
      ];
      // setCompanies(uniqueCompanies);
      setCompanies1(uniqueBranches);
    }
  }, [tableData]);
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setFileError("");
  };
  const updateComplianceDueDate = async (id, dueDate) => {
    const { data } = await requestApi(
      `/compliances/update/due-date`, // backend route
      "PUT",
      { id, due_date: dueDate } // send id inside body
    );
    return data;
  };

   const [showDetailModal,setShowDetail] =useState(false);
    async function getCopmlianceById(id) {
      setLoadingModal(true);
  
      try {
        const { data } = await requestApi(`/report/fetch/by-auditor/${id}`, {
          method: "get",
        });
  
        if (data) {
          setCompliance(data);
          setShowDetail(true);
        } else {
          toast.error("No data found.");
        }
      } catch (err) {
        console.log("error", err);
        toast.error("Something went wrong!");
      } finally {
        setLoadingModal(false);
      }
    }

     const isImageFile = (fileName) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const extension = fileName.split(".").pop().toLowerCase();
    return imageExtensions.includes(extension);
  };

  const cleanFileName = (filePath) => {
    return filePath.split("/").pop();
  };

  const getFileType = (fileName) => {
    const extension = fileName.split(".").pop().toUpperCase();
    return `${extension} File`;
  };

  const renderFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    const icons = {
      pdf: "https://cdn-icons-png.flaticon.com/512/337/337946.png",
      doc: "https://cdn-icons-png.flaticon.com/512/888/888879.png",
      xls: "https://cdn-icons-png.flaticon.com/512/888/888879.png",
      default: "https://cdn-icons-png.flaticon.com/512/833/833524.png",
    };
    const icon = icons[extension] || icons.default;
    return (
      <img
        src={icon}
        alt="File icon"
        style={{ width: "32px", height: "32px", marginRight: "8px" }}
      />
    );
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  
  const handleDateQuickFilter = (type) => {
    const now = new Date();

    switch (type) {
      case "This Month":
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        setTempStartDate(start);
        setTempEndDate(end);
        setStartDate(start); // Update the actual filter dates
        setEndDate(end); // Update the actual filter dates
        setSelectedRange("This Month");
        setIsOpen(false);
        return;
      case "Today":
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const todayEnd = new Date(today);
        todayEnd.setHours(23, 59, 59, 999);
        setTempStartDate(today);
        setTempEndDate(todayEnd);
        setStartDate(today); // Update the actual filter dates
        setEndDate(todayEnd); // Update the actual filter dates
        setSelectedRange("Today");
        setIsOpen(false);
        return;
      case "Yesterday":
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);
        const yesterdayEnd = new Date(yesterday);
        yesterdayEnd.setHours(23, 59, 59, 999);
        setTempStartDate(yesterday);
        setTempEndDate(yesterdayEnd);
        setStartDate(yesterday); // Update the actual filter dates
        setEndDate(yesterdayEnd); // Update the actual filter dates
        setSelectedRange("Yesterday");
        setIsOpen(false);
        return;
      case "Last 7 days":
        const today7 = new Date();
        today7.setHours(23, 59, 59, 999);
        const lastWeek = new Date();
        lastWeek.setDate(today7.getDate() - 6);
        lastWeek.setHours(0, 0, 0, 0);
        setTempStartDate(lastWeek);
        setTempEndDate(today7);
        setStartDate(lastWeek); // Update the actual filter dates
        setEndDate(today7); // Update the actual filter dates
        setSelectedRange("Last 7 days");
        setIsOpen(false);
        return;
      case "Last 30 days":
        const today30 = new Date();
        today30.setHours(23, 59, 59, 999);
        const last30 = new Date();
        last30.setDate(today30.getDate() - 29);
        last30.setHours(0, 0, 0, 0);
        setTempStartDate(last30);
        setTempEndDate(today30);
        setStartDate(last30); // Update the actual filter dates
        setEndDate(today30); // Update the actual filter dates
        setSelectedRange("Last 30 days");
        setIsOpen(false);
        return;
      case "Manual":
        setSelectedRange("Manual");
        return;
      default:
        return;
    }
  };

  const updatedue = async (id) => {
    const newDate = prompt("Enter new due date (YYYY-MM-DD):");
    if (!newDate) return;

    try {
      const response = await requestApi(`/compliances/update/due-date`, {
        method: "PUT",
        body: JSON.stringify({ id, due_date: newDate }),
        headers: { "Content-Type": "application/json" },
      });

      if (response?.status) {
        toast.success("Due date updated successfully!");
        await fetchReports(); // reload table data
      } else {
        toast.error(response?.message || "Failed to update");
      }
    } catch (err) {
      console.error(err);
      alert("Error updating due date");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      setFileError("Please select a file.");
      return;
    }
    const isExcel = /\.(xlsx|xls)$/i.test(selectedFile.name);
    if (!isExcel) {
      setFileError("Only Excel files (.xlsx or .xls) are allowed.");
      return;
    }
    setFileError("");
    const formData = new FormData();
    formData.append("file", selectedFile);
    setLoadingCount((prev) => prev + 1);
    try {
      const res = await axios.post(`${API_URL}/report/uploadReport`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(res?.data?.message || "Report uploaded successfully!");
      fetchReports();
      setSelectedFile(null);
      setShowModal(false);
      setSelectedComplianceIds([]);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Upload failed.");
    } finally {
      setLoadingCount((prev) => Math.max(prev - 1, 0));
    }
  };

  const toggleComplianceSelection = (id) => {
    const numericId = Number(id);
    setSelectedComplianceIds((prev) =>
      prev.includes(numericId)
        ? prev.filter((item) => item !== numericId)
        : [...prev, numericId]
    );
  };

  const allCurrentPageIds = currentTableData
    .map((row) => Number(row.id))
    .filter((id) => Number.isFinite(id));

  const isAllCurrentPageSelected =
    allCurrentPageIds.length > 0 &&
    allCurrentPageIds.every((id) => selectedComplianceIds.includes(id));

  const toggleSelectAllCurrentPage = () => {
    if (isAllCurrentPageSelected) {
      setSelectedComplianceIds((prev) =>
        prev.filter((id) => !allCurrentPageIds.includes(id))
      );
    } else {
      setSelectedComplianceIds((prev) => [
        ...new Set([...prev, ...allCurrentPageIds]),
      ]);
    }
  };

  const handleMultiDeleteCompliance = async () => {
    if (selectedComplianceIds.length === 0) {
      toast.info("Please select at least one compliance to delete.");
      return;
    }

    const confirmed = window.confirm(
      `Delete ${selectedComplianceIds.length} selected compliance(s)? This cannot be undone.`
    );
    if (!confirmed) return;

    setLoadingCount((prev) => prev + 1);
    try {
      const response = await requestApi(`/report/multiDeleteCompliance`, {
        method: "post",
        body: JSON.stringify({ ids: selectedComplianceIds }),
      });
      toast.success(
        response?.message || "Selected compliance(s) deleted successfully."
      );
      setSelectedComplianceIds([]);
      await fetchReports();
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Failed to delete selected compliances.");
    } finally {
      setLoadingCount((prev) => Math.max(prev - 1, 0));
    }
  };

  const toggleSelection = (company) => {
    setSelectedItems((prev) =>
      prev.includes(company)
        ? prev.filter((item) => item !== company)
        : [...prev, company]
    );
  };
  const toggleSelection1 = (branch) => {
    setSelectedItems1((prev) =>
      prev.includes(branch)
        ? prev.filter((item) => item !== branch)
        : [...prev, branch]
    );
  };
  const toggleAct = (act) => {
    setSelectedActs((prev) =>
      prev.includes(act) ? prev.filter((a) => a !== act) : [...prev, act]
    );
  };
  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }
  return (
    <section className="p-5">
      <div className=" ">
        <div className="d-flex justify-content-between">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ gap: "10px", width: "100%" }}
          >
            <div className="d-flex " style={{ gap: "10px", width: "100%" }}>
              <div className="d-flex gap-2  justify-content-between  w-100">
                <div className="d-flex gap-3">
                  <div
                    style={{
                      position: "relative",
                      // display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <button
                        className="btn p-2 shadow-sm d-flex align-items-center justify-content-center"
                        onClick={() => {
                          setShowSearch(!showSearch);
                          setSearchQuery("");
                        }}
                        style={{
                          minWidth: "40px",
                          height: "32px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                        }}
                      >
                        {showSearch ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="black"
                            viewBox="0 0 16 16"
                          >
                            <path d="M4.646 4.646a.5.5 0 011.415 0L8 6.586l1.939-1.94a.5.5 0 01.707.708L8.707 7.293l1.939 1.94a.5.5 0 01-.707.707L8 8.001 6.061 9.94a.5.5 0 11-.707-.707L7.293 8 5.354 6.061a.5.5 0 010-.707z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="black"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0
                         1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zm-5.24 1.106a5 5 0 1 1
                         0-10 5 5 0 0 1 0 10z"
                            />
                          </svg>
                        )}
                      </button>
                      {showSearch && (
                        <input
                          type="text"
                          placeholder="Search company or branch"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{
                            position: "absolute",
                            top: "45px",
                            left: 0,
                            width: "260px",
                            padding: "8px 10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            zIndex: 10,
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <Dropdown
                    label="Company Name"
                    options={companies}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                  />
                  <Dropdown
                    label="Sub Branch"
                    options={availableSubBranches}
                    selectedItems={selectedSubBranches}
                    setSelectedItems={setSelectedSubBranches}
                  />

                  <Dropdown
                    label="Branch Name"
                    options={companies1}
                    selectedItems={selectedItems1}
                    setSelectedItems={setSelectedItems1}
                  />
                  <ActDropdown
                    label="Act"
                    availableActs={availableActs}
                    selectedActs={selectedActs}
                    setSelectedActs={setSelectedActs}
                  />
                  <StatusDropdown
                    selected={selected}
                    setSelected={setSelected}
                  />
                  <div className="position-relative d-inline-block" ref={dateDropdownRef}>
                    <button
                      className="btn"
                      type="button"
                      data-bs-toggle="dropdown"
                      style={{
                        border: "1px solid #E4E4E7",
                        backgroundColor: "#FFFFFF",
                        color: "#1F1F23",
                        borderRadius: "5px",
                        padding: "6px 14px",
                        fontSize: "12px",
                        fontWeight: "500",
                        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                      onClick={() => setIsOpen(!isOpen)}
                      aria-expanded={isOpen}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                        alt="Calendar Icon"
                        width="16"
                        height="16"
                      />
                      <span>
                        {startDate && endDate
                          ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                          : "Select Date"}
                      </span>
                    </button>
                    {isOpen && (
                      <div
                        className="position-absolute mt-2 bg-white border shadow p-3"
                        style={{
                          zIndex: 1000,
                          width: "718px",
                          maxWidth: "95vw",
                          right: 0,
                          overflow: "hidden",
                        }}

                      >
                        <div className="row">
                          <div className="col-md-3">
                            <ul className="list-group">
                              <li
                                className={`list-group-item fs-12 ${
                                  selectedRange === "This Month"
                                    ? "bg-light rounded"
                                    : ""
                                }`}
                                onClick={() => handleDateQuickFilter("This Month")}
                                style={{ border: "none", cursor: "pointer" }}
                              >
                                This Month
                              </li>
                              <li
                                className={`list-group-item fs-12 ${
                                  selectedRange === "Today"
                                    ? "bg-light rounded"
                                    : ""
                                }`}
                                onClick={() => handleDateQuickFilter("Today")}
                                style={{ border: "none", cursor: "pointer" }}
                              >
                                Today
                              </li>
                              <li
                                className={`list-group-item fs-12 ${
                                  selectedRange === "Yesterday"
                                    ? "bg-light rounded"
                                    : ""
                                }`}
                                onClick={() => handleDateQuickFilter("Yesterday")}
                                style={{ border: "none", cursor: "pointer" }}
                              >
                                Yesterday
                              </li>
                              <li
                                className={`list-group-item fs-12 ${
                                  selectedRange === "Last 7 days"
                                    ? "bg-light rounded"
                                    : ""
                                }`}
                                onClick={() => handleDateQuickFilter("Last 7 days")}
                                style={{ border: "none", cursor: "pointer" }}
                              >
                                Last 7 days
                              </li>
                              <li
                                className={`list-group-item fs-12 ${
                                  selectedRange === "Last 30 days"
                                    ? "bg-light rounded"
                                    : ""
                                }`}
                                onClick={() => handleDateQuickFilter("Last 30 days")}
                                style={{ border: "none", cursor: "pointer" }}
                              >
                                Last 30 days
                              </li>
                              <li
                                className={`list-group-item fs-12 ${
                                  selectedRange === "Manual"
                                    ? "bg-light rounded"
                                    : ""
                                }`}
                                style={{ border: "none", cursor: "pointer" }}
                                onClick={() => handleDateQuickFilter("Manual")}
                              >
                                Manual
                              </li>
                            </ul>
                          </div>
                          {selectedRange === "Manual" && (
                          <div className="col-md-9 border-start">
                            <div className="d-flex justify-content-between">
                              <h5 className="fs-12">
                                {tempStartDate?.toLocaleString("default", {
                                  month: "long",
                                  year: "numeric",
                                }) || "Start"}
                              </h5>
                              <h5 className="fs-12">
                                {tempEndDate?.toLocaleString("default", {
                                  month: "long",
                                  year: "numeric",
                                }) || "End"}
                              </h5>
                            </div>
                            <div className="row">
                              <div className="col-md-6">
                                <DatePicker
                                  selected={startDate}
                                  onChange={(date) => {
                                    if (date) {
                                      const normalizedDate = new Date(date);
                                      normalizedDate.setHours(0, 0, 0, 0);
                                      setTempStartDate(normalizedDate);
                                      // If start date is after end date, update end date
                                      if (normalizedDate > tempEndDate) {
                                        const newEnd = new Date(normalizedDate);
                                        newEnd.setHours(23, 59, 59, 999);
                                        setTempEndDate(newEnd);
                                      }
                                      setSelectedRange("Manual");
                                    }
                                  }}
                                  inline
                                />
                              </div>
                              <div className="col-md-6">
                                <DatePicker
                                  selected={endDate}
                                  onChange={(date) => {
                                    if (date) {
                                      const normalizedDate = new Date(date);
                                      normalizedDate.setHours(23, 59, 59, 999);
                                      setTempEndDate(normalizedDate);
                                      // If end date is before start date, update start date
                                      if (normalizedDate < tempStartDate) {
                                        const newStart = new Date(normalizedDate);
                                        newStart.setHours(0, 0, 0, 0);
                                        setTempStartDate(newStart);
                                      }
                                      setSelectedRange("Manual");
                                    }
                                  }}
                                  minDate={tempStartDate}
                                  inline
                                />
                              </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between align-items-center">
                              <div
                                style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                                id="selected-range"
                                className="btn  "
                              >
                                <span id="start-display"  style={{
                                backgroundColor: "#343a40",
                                color: "#fff",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "12px",
                              }}>
                                  {tempStartDate
                                    ? tempStartDate.toLocaleDateString()
                                    : "--"}
                                </span>{" "}
                              <span style={{ fontSize: "16px", color: "#000" }}>  →{" "}</span>
                                <span   style={{
                                backgroundColor: "#343a40",
                                color: "#fff",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "12px",
                              }}id="end-display">
                                  {tempEndDate
                                    ? tempEndDate.toLocaleDateString()
                                    : "--"}
                                </span>
                              </div>
                              <button
                                className="btn btn-dark fs-12"
                                onClick={() => {
                                  // Normalize dates before applying
                                  const normalizedStart = new Date(tempStartDate);
                                  normalizedStart.setHours(0, 0, 0, 0);
                                  const normalizedEnd = new Date(tempEndDate);
                                  normalizedEnd.setHours(23, 59, 59, 999);
                                  setStartDate(normalizedStart);
                                  setEndDate(normalizedEnd);
                                  setTempStartDate(normalizedStart);
                                  setTempEndDate(normalizedEnd);
                                  // If dates don't match any quick filter, set to Manual
                                  if (selectedRange !== "Manual") {
                                    const now = new Date();
                                    const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                                    currentMonthStart.setHours(0, 0, 0, 0);
                                    const currentMonthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                                    currentMonthEnd.setHours(23, 59, 59, 999);
                                    
                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);
                                    const todayEnd = new Date(today);
                                    todayEnd.setHours(23, 59, 59, 999);
                                    
                                    const yesterday = new Date();
                                    yesterday.setDate(yesterday.getDate() - 1);
                                    yesterday.setHours(0, 0, 0, 0);
                                    const yesterdayEnd = new Date(yesterday);
                                    yesterdayEnd.setHours(23, 59, 59, 999);
                                    
                                    const last7Start = new Date();
                                    last7Start.setDate(last7Start.getDate() - 6);
                                    last7Start.setHours(0, 0, 0, 0);
                                    const last7End = new Date();
                                    last7End.setHours(23, 59, 59, 999);
                                    
                                    const last30Start = new Date();
                                    last30Start.setDate(last30Start.getDate() - 29);
                                    last30Start.setHours(0, 0, 0, 0);
                                    const last30End = new Date();
                                    last30End.setHours(23, 59, 59, 999);
                                    
                                    if (normalizedStart.getTime() === currentMonthStart.getTime() && 
                                        normalizedEnd.getTime() === currentMonthEnd.getTime()) {
                                      setSelectedRange("This Month");
                                    } else if (normalizedStart.getTime() === today.getTime() && 
                                               normalizedEnd.getTime() === todayEnd.getTime()) {
                                      setSelectedRange("Today");
                                    } else if (normalizedStart.getTime() === yesterday.getTime() && 
                                               normalizedEnd.getTime() === yesterdayEnd.getTime()) {
                                      setSelectedRange("Yesterday");
                                    } else if (normalizedStart.getTime() === last7Start.getTime() && 
                                               normalizedEnd.getTime() === last7End.getTime()) {
                                      setSelectedRange("Last 7 days");
                                    } else if (normalizedStart.getTime() === last30Start.getTime() && 
                                               normalizedEnd.getTime() === last30End.getTime()) {
                                      setSelectedRange("Last 30 days");
                                    } else {
                                      setSelectedRange("Manual");
                                    }
                                  }
                                  setIsOpen(false);
                                }}
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  {selectedComplianceIds.length > 0 && (
                    <button
                      type="button"
                      className="btn fs-12 btn-outline-danger"
                      onClick={handleMultiDeleteCompliance}
                      style={{
                        padding: "6px 14px",
                        borderRadius: "5px",
                        fontWeight: 500,
                      }}
                    >
                      Delete Selected ({selectedComplianceIds.length})
                    </button>
                  )}
                  <button
                    className="btn fs-12 upload-btn"
                    onClick={() => setShowModal(true)}
                  >
                    Upload Report
                  </button>
                </div>

                    {showModal && (
                      <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        style={{
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        <div
                          className="modal-dialog modal-dialog-centered"
                          role="document"
                        >
                          <div
                            className="modal-content p-4"
                            style={{ borderRadius: "12px" }}
                          >
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="modal-title fw-bold fs-12">
                                Create Report
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowModal(false)}
                              />
                            </div>
                            <form onSubmit={handleSubmit}>
                              <div className="mb-3">
                                <label className="fs-12">
                                  Upload Report List
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  onChange={handleFileChange}
                                  accept=".xlsx,.xls"
                                />
                                <div style={{ marginTop: "6px" }}>
                                  <a
                                    href={`${API_URL}/uploads/sheet.xlsx`}
                                    download
                                    style={{
                                      fontSize: "12px",
                                      color: "#0d6efd",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Download Sample
                                  </a>
                                </div>
                                {fileError && (
                                  <div
                                    style={{
                                      color: "red",
                                      fontSize: "12px",
                                      marginTop: "4px",
                                    }}
                                  >
                                    {fileError}
                                  </div>
                                )}
                              </div>
                              <div className="text-end mt-4">
                                <button
                                  type="submit"
                                  className="btn fs-12"
                                  style={{
                                    backgroundColor: "#1F1F23",
                                    color: "#fff",
                                    padding: "6px 14px",
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Upload Report
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <div className="">
          <div className="card-body p-0">
            <div className="table-responsive">
               <div className="table-scroll">
              <table className="table table-hover align-middle mt-0 rounded vertical-border">
                <thead
                  className="bg-light text-nowrap fs-12 table-color"

                >
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={isAllCurrentPageSelected}
                        onChange={toggleSelectAllCurrentPage}
                        title="Select all on this page"
                      />
                    </th>
                    <th>Sr No</th>
                    <th>Entity</th>
                    <th>Branch Name</th>
                    <th>Legislations</th>
                    <th>Due Date</th>
                    <th>Audited Date</th>
                    <th>Assigned Auditor</th>
                    <th>Compliance Officer</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "12px" }}>
                  {currentTableData.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="text-center py-3">
                        No records found.
                      </td>
                    </tr>
                  ) : (
                    currentTableData.map((row, index) => (
                      <tr key={row.id || index}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedComplianceIds.includes(
                              Number(row.id)
                            )}
                            onChange={() => toggleComplianceSelection(row.id)}
                          />
                        </td>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{row.companyName}</td>
                        <td>{row.branchName}</td>
                        <td>{row.act}</td>
                        <td>
                          {new Date(row.dueDate).toLocaleDateString("en-GB")}
                          <a
                            onClick={() => updatedue(Number(row.id))}
                            className="super-reportbtn "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pencil"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M12.146.146a.5.5 0 0 1 .708 0l3 
        3a.5.5 0 0 1 0 .708l-10 10a.5.5 
        0 0 1-.168.11l-5 2a.5.5 0 0 
        1-.65-.65l2-5a.5.5 0 0 
        1 .11-.168l10-10zM11.207 
        2L13 3.793 14.793 2 13 
        .207 11.207 2zM12 4L10 2 
        3 9v2h2l7-7z"
                              />
                            </svg>
                          </a>
                        </td>

                        <td>
                          {new Date(row.auditedDate).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>

                        <td>{row.assignedAuditor}</td>
                        <td>{row.complianceOfficer}</td>
                        <td>
                          {/* <button className="open-btn d-flex align-items-center gap-1">
                            <img
                              src={row.status === 0 ? VectorIcon : Closed}
                              alt={row.status === 0 ? "open" : "closed"}
                            />
                            {row.status === 0 ? "Open" : "Closed"}
                          </button> */}
                          <button
                            className="closeandopen-btn"
                            onClick={() => getCopmlianceById(Number(row.id))}
                            style={{
                              color:
                                row.status === 0
                                  ? "rgba(255, 140, 0, 1)"
                                  : "rgba(255, 140, 0, 1)"
                            }}
                          >
                            <img
                              src={row.status == 0 ? VectorIcon : Closed}
                              alt={row.status == 0 ? "open" : "closed"}
                              style={{ width: 16, height: 16 }}
                            />
                            {row.status == 0 ? "Open" : "Closed"}
                          </button>


                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              </div>
                             {(showDetailModal || loading) && (
                              <div
                                className="modal fade show d-block"
                                tabIndex="-1"
                                role="dialog"
                                style={{
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                }}
                              >
                                <div
                                  className="modal-dialog modal-dialog-centered"
                                  role="document"
                                  style={{ maxWidth: "800px", width: "100%" }}
                                >
                                  <div
                                    className="modal-content p-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                      <h5 className="modal-title fs-12">VERIFY REPORT</h5>
                                      <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowDetail(false)}
                                      />
                                    </div>
                                    <form>
                                      <div>
                                        <h4 className="fs-12">
                                          Procedure for nomination{" "}
                                          <span
                                            style={{
                                              display: "inline-block",
                                              padding: "2px 8px",
                                              backgroundColor: "#f3f4f6",
                                              color: "#1f2937",
                                              borderRadius: "12px",
                                              fontSize: "12px",
                                              fontWeight: "500",
                                              boxShadow: "0 0 0 1px #d1d5db",
                                            }}
                                          >
                                            {compliance?.provision}
                                          </span>
                                        </h4>
                                        <p
                                          className="text-muted"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {" "}
                                          <strong style={{ fontSize: "12px" }}>
                                            {" "}
                                            Compliance Description:{" "}
                                          </strong>
                                          {compliance?.compliance || "NA"}
                                        </p>
                                        <p
                                          className="text-muted"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {" "}
                                          <strong style={{ fontSize: "12px" }}>
                                            {" "}
                                            Penalty Type:{" "}
                                          </strong>
                                          {compliance?.penalty_type || "NA"}
                                        </p>
                                        <p
                                          className="text-muted"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {" "}
                                          <strong style={{ fontSize: "12px" }}>
                                            {" "}
                                            Penalty Description :{" "}
                                          </strong>
                                          {compliance?.penalty_description || "NA"}
                                        </p>
                                        <strong className="fs-12">Select Status</strong>
                                        <br />
                                        <div
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            backgroundColor:
                                              compliance?.current_compliance_status === "Complied"
                                                ? "#d1fae5"
                                                : compliance?.current_compliance_status === "Partial Complied"
                                                  ? "#fef9c3"
                                                  : compliance?.current_compliance_status === "Not Complied"
                                                    ? "#fee2e2"
                                                    : compliance?.current_compliance_status === "Not Applicable"
                                                      ? "#e0f2fe"
                                                      : "#ffe8dc", // fallback (light orange)
                                            color:
                                              compliance?.current_compliance_status === "Complied"
                                                ? "#065f46"
                                                : compliance?.current_compliance_status === "Partial Complied"
                                                  ? "#92400e"
                                                  : compliance?.current_compliance_status === "Not Complied"
                                                    ? "#991b1b"
                                                    : compliance?.current_compliance_status === "Not Applicable"
                                                      ? "#1e40af"
                                                      : "#9a3412", // fallback (dark orange)
                                            border:
                                              compliance?.current_compliance_status === "Complied"
                                                ? "1px solid #10b981"
                                                : compliance?.current_compliance_status === "Partial Complied"
                                                  ? "1px solid #facc15"
                                                  : compliance?.current_compliance_status === "Not Complied"
                                                    ? "1px solid #ef4444"
                                                    : compliance?.current_compliance_status === "Not Applicable"
                                                      ? "1px solid #3b82f6"
                                                      : "1px solid #f9964bff", // fallback (orange)
                                            borderRadius: "4px",
                                            padding: "4px 12px",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8px",
                                              height: "8px",
                                              backgroundColor:
                                                compliance?.current_compliance_status === "Complied"
                                                  ? "#10b981"
                                                  : compliance?.current_compliance_status === "Partial Complied"
                                                    ? "#facc15"
                                                    : compliance?.current_compliance_status === "Not Complied"
                                                      ? "#ef4444"
                                                      : compliance?.current_compliance_status === "Not Applicable"
                                                        ? "#3b82f6"
                                                        : "#f9964bff", // fallback (orange)
                                              borderRadius: "50%",
                                              marginRight: "8px",
                                            }}
                                          ></span>
                                          {compliance?.current_compliance_status || "NA"}
                                        </div>
              
                                        <div className="mb-3">
                                          <label className="form-label fw-semibold fs-12">
                                            Attached Proof
                                          </label>
                                          {compliance?.proof_file &&
                                            compliance.proof_file !== "" ? (
                                            <div
                                              className="border p-2 rounded bg-light mt-2"
                                              style={{ fontSize: "12px", width: "300px" }}
                                            >
                                              {!isImageFile(compliance.proof_file) ? (
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <div className="d-flex align-items-center">
                                                    {renderFileIcon(compliance.proof_file)}
                                                    <div className="ml-2">
                                                      <div>
                                                        <strong>
                                                          {cleanFileName(
                                                            compliance.proof_file
                                                          )}
                                                        </strong>
                                                      </div>
                                                      <div
                                                        style={{
                                                          fontSize: "10px",
                                                          color: "#888",
                                                        }}
                                                      >
                                                        {getFileType(compliance.proof_file)}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <a
                                                    href={`${API_URL}/${compliance.proof_file}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-sm btn-dark"
                                                    style={{ fontSize: "10px" }}
                                                  >
                                                    View
                                                  </a>
                                                </div>
                                              ) : (
                                                <img
                                                  src={`${API_URL}/${compliance.proof_file}`}
                                                  alt="Proof File"
                                                  style={{
                                                    width: "100%",
                                                    maxHeight: "150px",
                                                    objectFit: "contain",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#f0f0f0",
                                                  }}
                                                  className="mt-2"
                                                />
                                              )}
                                            </div>
                                          ) : (
                                            <div className="fw-normal text-dark">NA</div>
                                          )}
                                        </div>
                                        <div>
                                          <label className="text-xs font-medium">
                                            Attached Proof Link
                                          </label>
                                        </div>
                                        <a
                                          href={encodeURI(compliance?.proofs_link)}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {compliance?.proofs_link || "NA"}
                                        </a>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "16px",
                                            paddingTop: "16px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              flex: "1 1 45%",
                                              minWidth: "280px",
                                            }}
                                          >
                                            <h4
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                color: "#1f2937",
                                                marginBottom: "4px",
                                              }}
                                            >
                                              Compliancer Officer Comment
                                            </h4>
                                            <p
                                              style={{
                                                fontSize: "14px",
                                                color: "#4b5563",
                                              }}
                                            >
                                              {compliance?.comment_of_officer || "NA"}
                                            </p>
                                          </div>
                                          <div
                                            style={{
                                              flex: "1 1 45%",
                                              minWidth: "280px",
                                            }}
                                          >
                                            <h4
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                color: "#1f2937",
                                                marginBottom: "4px",
                                              }}
                                            >
                                              Compliancer Officer Description
                                            </h4>
                                            <p
                                              style={{
                                                fontSize: "12px",
                                                color: "#4b5563",
                                              }}
                                            >
                                              {compliance?.compliance_description || "NA"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            )}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-4">
        <select
          className="form-select form-select-sm w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value));
            setCurrentPage(1);
          }}
          style={{ position: "relative", zIndex: 1 }}
        >
          <option value={10}>10 Pages</option>
          <option value={20}>20 Pages</option>
          <option value={30}>30 Pages</option>
        </select>
        <nav>
          <ul className="pagination mb-0 d-flex align-items-center gap-2">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link text-dark border-0 bg-transparent"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              >
                Previous
              </button>
            </li>
            {currentPage > 3 && (
              <>
                <li
                  className={`page-item ${currentPage === 1 ? "active" : ""}`}
                >
                  <button
                    className={`page-link fw-bold rounded-circle border-0 ${currentPage === 1
                      ? "bg-dark text-white"
                      : "bg-transparent text-dark"
                      }`}
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>
                </li>
                <li className="page-item disabled">
                  <span className="page-link bg-transparent border-0">...</span>
                </li>
              </>
            )}
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(
                (page) =>
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 2 && page <= currentPage + 2)
              )
              .map((page) => (
                <li
                  key={page}
                  className={`page-item ${currentPage === page ? "active" : ""
                    }`}
                >
                  <button
                    className={`page-link fw-bold rounded-circle border-0 ${currentPage === page
                      ? "bg-dark text-white"
                      : "bg-transparent text-dark"
                      }`}
                    onClick={() => setCurrentPage(page)}
                    style={{
                      width: "36px",
                      height: "36px",
                      padding: 0,
                      lineHeight: "36px",
                      textAlign: "center",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {page}
                  </button>
                </li>
              ))}
            {currentPage < totalPages - 2 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link bg-transparent border-0">...</span>
                </li>
                <li
                  className={`page-item ${currentPage === totalPages ? "active" : ""
                    }`}
                >
                  <button
                    className={`page-link fw-bold rounded-circle border-0 circle ${currentPage === totalPages
                      ? "bg-dark text-white"
                      : "bg-transparent text-dark"
                      }`}
                    onClick={() => setCurrentPage(totalPages)}
                  >
                    {totalPages}
                  </button>
                </li>
              </>
            )}
            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <button
                className="page-link text-dark border-0 bg-transparent"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}
export default Report;
